import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import ActiveTickets from './components/ActiveTickets'
import {ROLE} from "../auth";
import {PrivateRoute} from "../auth/PrivateRoute";
import FinishedTickets from "./components/FinishedTickets";
import ReportTickets from "./components/ReportTickets";
import TicketInfo from "./components/TicketInfo";
import PayoutRefusalsPage from "./refusals/PayoutRefusalsPage";
import { PAYOUT_REFUSAL_ROLES } from "./refusals/core/consts";
import { PayoutRefusalCardPage } from "../ticket-card";

const PayoutTicketsPage: React.FC = () => {
    return (
        <Routes>
            <Route element={<><Outlet /></>}>
                <Route path='active' element={
                    <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_CASHIER, ROLE.ROLE_CASHIER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_OPERATOR, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}>
                        <ActiveTickets />
                    </PrivateRoute>
                }/>
                <Route path='finished' element={
                    <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_CASHIER, ROLE.ROLE_CASHIER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_OPERATOR, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}>
                        <FinishedTickets />
                    </PrivateRoute>
                }/>
                <Route path='report' element={
                    <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_CASHIER, ROLE.ROLE_SENIOR_OPERATOR]}>
                        <ReportTickets />
                    </PrivateRoute>
                }/>
                <Route path='ticket-info/:id' element={
                    <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_CASHIER, ROLE.ROLE_CASHIER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_OPERATOR, ROLE.ROLE_MATCHING_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]}>
                        <TicketInfo />
                    </PrivateRoute>
                }/>
                <Route path='refusals' element={
                    <PrivateRoute roles={PAYOUT_REFUSAL_ROLES}>
                        <PayoutRefusalsPage />
                    </PrivateRoute>
                }/>
                <Route path='refusal/:id' element={
                    <PrivateRoute roles={PAYOUT_REFUSAL_ROLES}>
                        <PayoutRefusalCardPage />
                    </PrivateRoute>
                }/>
                <Route index element={<Navigate to='/active' />} />
            </Route>
        </Routes>
    )
}

export default PayoutTicketsPage
